export default {
	people: {
		title: "Gestión Personas",
	},
	spiritualManagement: {
		title: "Gestión Espiritual",
	},
	ritualManagement: {
		title: "Gestión Rituales",
	},
	templeManagement: {
		title: "Gestión Templo",
	},
	tools: {
		title: "Herramientas",
	},
};
